import { ArrowUp, ArrowDown, X, Scissors } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { fmt } from "@/lib/reels";

export function ReelTimeline({ segments, clipsById, durations, onUpdate, onMove, onRemove }) {
    if (segments.length === 0) {
        return (
            <div className="border border-dashed border-border rounded-sm p-8 text-center text-muted-foreground" data-testid="timeline-empty">
                <Scissors className="w-6 h-6 mx-auto mb-2 opacity-60" />
                <p className="text-sm">Your timeline is empty. Add clips from your library to start building.</p>
            </div>
        );
    }
    return (
        <div className="space-y-3" data-testid="reel-timeline">
            {segments.map((seg, i) => {
                const clip = clipsById[seg.clip_id] || {};
                const max = Math.max(2, Math.ceil(durations[seg.clip_id] || clip.duration_sec || 30));
                return (
                    <div key={`${seg.clip_id}-${i}`} data-testid={`timeline-seg-${i}`}
                        className="bg-surface border border-border rounded-sm p-3 flex flex-col sm:flex-row gap-3">
                        <div className="flex items-center gap-2 sm:w-44 shrink-0">
                            <span className="grid place-items-center w-6 h-6 rounded-sm bg-volt/15 text-volt text-xs font-mono shrink-0">{i + 1}</span>
                            <div className="min-w-0">
                                <div className="text-sm text-white truncate">{clip.title || "Clip"}</div>
                                <div className="text-[10px] font-mono text-muted-foreground uppercase">{clip.event_type}</div>
                            </div>
                        </div>
                        <div className="flex-1 space-y-2">
                            <div className="flex items-center gap-2">
                                <span className="text-[10px] font-mono text-muted-foreground w-8">{fmt(seg.in_sec)}</span>
                                <Slider value={[seg.in_sec, seg.out_sec]} min={0} max={max} step={0.5} minStepsBetweenThumbs={1}
                                    onValueChange={([a, b]) => onUpdate(i, { in_sec: a, out_sec: b })}
                                    className="flex-1" data-testid={`trim-${i}`} />
                                <span className="text-[10px] font-mono text-muted-foreground w-8">{fmt(seg.out_sec)}</span>
                            </div>
                            <Input value={seg.caption || ""} onChange={(e) => onUpdate(i, { caption: e.target.value })}
                                placeholder="Add a caption (optional)" maxLength={60}
                                className="bg-obsidian border-border rounded-sm h-8 text-xs" data-testid={`caption-${i}`} />
                        </div>
                        <div className="flex sm:flex-col items-center justify-end gap-1 shrink-0">
                            <button onClick={() => onMove(i, -1)} disabled={i === 0} className="text-muted-foreground hover:text-white disabled:opacity-30" data-testid={`seg-up-${i}`}><ArrowUp className="w-4 h-4" /></button>
                            <button onClick={() => onMove(i, 1)} disabled={i === segments.length - 1} className="text-muted-foreground hover:text-white disabled:opacity-30" data-testid={`seg-down-${i}`}><ArrowDown className="w-4 h-4" /></button>
                            <button onClick={() => onRemove(i)} className="text-muted-foreground hover:text-alert" data-testid={`seg-remove-${i}`}><X className="w-4 h-4" /></button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
